import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import classes from './CoachHeaderInfo.module.scss'
import Avatar from '../common/avatar/deprecated/Avatar'
import { ReactComponent as AnnouncementIcon } from '../../assets/images/common/icons/announcement-icon.svg'

const CoachHeaderInfo = ({ coach }) => {
  const { t } = useTranslation()

  return (
    <div className={classes.container}>
      <div className={classes.coachAvatarContainer}>
        <Avatar
          className='img-responsive'
          imageUrl={coach?.avatar?.file_url}
          hasCoachLabel
          hasBorder
          altName={coach?.first_name + ' ' + coach?.last_name}
        />

        <div className={classes.profileInfoContainer}>
          <div className={classes.coachNameContainer}>
            <h5 className={classes.coachName}>
              {coach?.first_name} {coach?.last_name}
            </h5>
            <div className={classes.coachPill}>
              {t('activity.common.coach')}
            </div>
          </div>
          <div className={classes.coachTitle}>
            {t('activity.coachHeader.coachAnnouncement')}
          </div>
        </div>
      </div>
      <div className={classes.announcementIcon}>
        <AnnouncementIcon className={classes.icon}/>
      </div>
    </div>
  )
}

CoachHeaderInfo.propTypes = {
  coach: PropTypes.object.isRequired,
}

export default CoachHeaderInfo
